var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShadowTriangle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 140,
    viewBox: "0 0 372 140",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "591.849 1456.271 449 1596 820.534 1596 692.591 1456.271",
    opacity: 0.504,
    transform: "translate(-449 -1456)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShadowTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shadow-triangle.d033c936.svg";
export { ForwardRef as ReactComponent };